import { OnInit, Component, OnDestroy } from '@angular/core';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/shared/global.service';
import { AtencionCiudadanoUACComponent } from './atencion-ciudadano-UAC.component';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { TurnoUACModel } from 'src/app/models/turnoUAC.model';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { FuncionarioModel } from 'src/app/models/funcionario.model';
import { TurnoFuncionarioUACModel } from 'src/app/models/turnoFuncionarioUAC.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { VentanillaEsperaUACComponent } from './ventanilla-espera-UAC.component';
import { ConsultaTurnosUACComponent } from './consulta-turnos-UAC.component';
import { TramiteUACModel } from 'src/app/models/tramiteUAC.model';
import { Subscription } from 'rxjs';
import { ServicioFuncionarioModel } from 'src/app/models/servicioFuncionario.model';
import { UtilService } from 'src/app/shared/services/util.service';
import { TransferirTurnoUACComponent } from './transferir-turno-UAC.component';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { SeleccionVentanillaComponent, DatosVentanilla } from './seleccion-ventanilla.component';

@Component({
    selector: 'app-atender-ciudadano-UAC',
    templateUrl: './atender-ciudadano-UAC.component.html',
    styleUrls: ['./atender-ciudadano-UAC.component.scss']
})

export class AtenderCiudadanoUACComponent implements OnInit, OnDestroy {

    public sedeActual;
    public turnosAsignados: string;
    public turno: TurnoUACModel;
    public tramiteActual: TramiteUACModel;
    public turnosTramite: TramiteUACModel[];
    public spinner1 = 'sp6';
    public contadorUAC = 0;
    public modalOptionsFinFuncionario: ConfirmationModalOptions;
    public modalOptionsCambioTramite: ConfirmationModalOptions;
    public modalOptionsAbandono: ConfirmationModalOptions;
    public tipoTramite: string;
    public inhabilitarBotonFuncionario: boolean;
    public listadoTipoDocumento: any;
    public funcionario: FuncionarioModel;
    public turnoFuncionario: TurnoFuncionarioUACModel;
    public inhabilitarCampos: boolean;
    public listaTramites: any;
    public tramiteAtender: any;
    public inhabilitarBotonAtencion: boolean;
    public inhabilitarBotonTransferir: boolean;
    public inhabilitarBotonEspera: boolean;
    private tiempoContador: any;
    public parametros: any;
    public subscription: Subscription[] = [];
    private ventanillaActual;
    private servicioFuncionario: ServicioFuncionarioModel;
    private timerDistraido: any;
    private timerSpinner: any;
    private turnoLlamado: boolean;
    public timerLlamadoAutomatico: any;
    public timeOutllamadoAutomatico: any;
    public inhabilitarBotonLlamar: boolean;
    public tramitesFuncionario: any;
    public inhabilitarBotonBuscarFuncionario: boolean;
    public inhabilitarCambioTramite: boolean;
    public listaParametros: string[] = [DominiosService.PRM_TIEMPO_CONTADOR_VENTANILLA,
    DominiosService.PRM_TIEMPO_LLAMADO_AUTO_TURNO];

    private ultimoError = '';

    constructor(private alertService: AlertService, private spiner: NgxSpinnerService
        , private global: GlobalService, private modalService: NgbModal,
        private urlService: UrlService, private util: UtilService) {
        this.turnosAsignados = '';
        this.turno = new TurnoUACModel();
        this.subscription = [];
        this.tramiteActual = new TramiteUACModel();
        this.inicializarModales();
        this.inhabilitarBotonFuncionario = true;
        this.inhabilitarBotonTransferir = true;
        this.inhabilitarBotonAtencion = true;
        this.listadoTipoDocumento = [];
        this.listaTramites = [];
        this.turnosTramite = [];
        this.turnoFuncionario = new TurnoFuncionarioUACModel();
        this.inhabilitarCampos = false;
        this.sedeActual = 'PRINC';
        this.inhabilitarBotonEspera = false;
        this.timerLlamadoAutomatico = 5000;
        this.timeOutllamadoAutomatico = [];
        this.inhabilitarBotonLlamar = false;
        this.tramitesFuncionario = [];
        this.turnoLlamado = false;
        this.inhabilitarBotonBuscarFuncionario = false;
        this.inhabilitarCambioTramite = false;

    }
    ngOnInit() {
        this.cargaDatosAtencion();
        this.obtenerParametroTiempo();
    }

    /**
     * Abre el modal y permite configurar la ventanilla y la sede del funcionario
     */
    cargaDatosAtencion() {
        const modalRef = this.modalService.open(SeleccionVentanillaComponent, { centered: true, size: 'lg' });


        modalRef.result.then((result: DatosVentanilla) => {
            if (result) {
                this.ventanillaActual = result.ventanilla;
                this.sedeActual = result.sede;
                this.obtenerConfiguracionUsuarioVentanilla();

            }
        }, (reason) => {
            if (reason === ModalDismissReasons.ESC ||
                reason === ModalDismissReasons.BACKDROP_CLICK) {
                this.cathException('Por favor seleccione la sede y ventanilla actual para continuar');
                // this.cargaDatosAtencion();
            }
        });
    }


    /**
     * Obtiene el parametro tiempo del contador de la ventanilla
     * @author klagos@asesoftware.com
     */
    obtenerParametroTiempo() {
        const serviceProvider = 'consultarParametros';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
        const suscripcion = this.global.postGenerico(url, this.listaParametros).subscribe(
            data => {
                this.parametros = data;
                this.setParametroTiempoContador();
            }, err => {
                this.cathException('Error Consultando parametros');
            }
        );
        this.subscription.push(suscripcion);
    }

    /**
     * filtra los paràmetros y obtiene el tiempo del contador de llamado a turno
     * @author fromero
     */
    setParametroTiempoContador() {

        const tiempoContador = this.parametros.filter(el => {
            if (el.nombre === DominiosService.PRM_TIEMPO_CONTADOR_VENTANILLA) {
                return el;
            }
        });
        const tiempoLlamadoAutomatico = this.parametros.filter(param => {
            if (param.nombre === DominiosService.PRM_TIEMPO_LLAMADO_AUTO_TURNO) {
                return param;
            }
        })
        this.tiempoContador = tiempoContador[0].valor * 1000;
        this.timerLlamadoAutomatico = tiempoLlamadoAutomatico[0].valor * 1000;
    }

    /**
     * Inicializa modales y los valida an iniciar la aplicacion
     */
    inicializarModales() {
        this.modalOptionsFinFuncionario = new ConfirmationModalOptions('Confirmaciòn', '¿Está seguro de finalizar atención?', 'SI', 'NO', 'fas fa-flag-checkered', true, null, 'Finalizar Atenciòn', null, 'btn btn-secondary');

        this.modalOptionsAbandono = new ConfirmationModalOptions('Confirmaciòn', '¿Está seguro de registrar abandono del turno?', 'SI', 'NO', 'far fa-times-circle', true, null,
            'Turno Abandonado', null, 'btn btn-danger btn-block btn-lg');

        this.modalOptionsCambioTramite = new ConfirmationModalOptions('Confirmaciòn', '¿Está seguro de cambiar el trámite de atención en ventanilla?', 'SI', 'NO', 'fas fa-sync', true, null,
            'Actualizar Servicio', null, 'btn btn-secondary btn-block btn-lg');
    }


    /**
     * obtiene la configuraciòn inicial de la ventanilla para asignar el servicio inicial, validar si tiene un turno cargado
     * camilo
     * @author fromero
     */
    obtenerConfiguracionUsuarioVentanilla() {
        this.spiner.show();
        const serviceProvider = 'obtenerConfiguracionVentanilla';

        var queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tipoDocFunc', sessionStorage.getItem('tipoDocumento')]);
        queryParams.push(['numDocFunc', sessionStorage.getItem('numDocumento')]);
        queryParams.push(['sede', this.sedeActual]);
        queryParams.push(['ventanilla', this.ventanillaActual]);

        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        const sucripcion = this.global.getGenerico(url).subscribe(
            data => {
                const configuracion = data;
                //da prioridad al tipo de tramite de funcionario
                configuracion.forEach(element => {
                    if (element.idTramite == ConstantesService.ID_TRAMITE_FUNCIONARIO) {
                        this.tipoTramite = ConstantesService.TRAMITE_FUNCIONARIO;
                        this.ventanillaActual = element.numeroVentanilla;
                        this.tramiteActual.idTramite = element.idTramite;
                        this.ventanillaDisponible();
                    }
                });
                if (this.tipoTramite != ConstantesService.TRAMITE_FUNCIONARIO) {
                    this.ventanillaActual = data[0].numeroVentanilla;
                    this.tramiteActual.idTramite = data[0].idTramite;
                    if (data[0].estadoVentanilla == 'ESP') {
                        this.inhabilitarBotonEspera = true;
                        this.ventanillaDisponible();
                    }
                }
                this.verificarTurnoAtencion();
                this.getTipoIdentificacion();
                this.getTramites();
                this.getTramitesFuncionario();
            }, err => {
                this.inhabilitarBotonEspera = true;
                this.inhabilitarBotonLlamar = true;
                this.cathException(err.error.message);
            }
        );
        this.subscription.push(sucripcion);
    }


    /**
     * Consulta si habìa un turno en atención para la ventanilla
     * camilo
     * @author fromero
     */
    verificarTurnoAtencion() {

        this.spiner.show();
        const serviceProvider = 'getTurnoActualVentanilla';
        var queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['numeroVentanilla', this.ventanillaActual]);
        queryParams.push(['sede', this.sedeActual]);
        var url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        const sucripcion = this.global.getGenerico(url).subscribe(
            data => {
                if (data) {
                    this.turno = data;
                    this.alertService.generateAlertSuccess('Se encontró un turno pendiente por atención para esta vetanilla', '');

                    if (this.turno.idTramite != ConstantesService.TRAMITE_FUNCIONARIO) {
                        this.tipoTramite = '';
                    }

                    if (this.turno.estado == ConstantesService.ESTADO_TURNO_EN_TRAMITE) {
                        this.guardarInicioAtencionciudadano();
                    } else if (this.turno.estado == ConstantesService.ESTADO_TURNO_LLAMADO) {
                        this.verSpinner(this.spinner1);
                        this.inhabilitarBotonAtencion = false;
                        this.inhabilitarBotonLlamar = true;
                        this.modalOptionsAbandono.disabled = false;
                        this.inhabilitarBotonEspera = true;
                        this.inhabilitarCambioTramite = true;
                        this.turnoLlamado = true;
                    }
                }
            }, err => {
                this.turnoLlamado = false;
                this.cathException('Error Consultando la lista de tramites');
            }
        );
        this.subscription.push(sucripcion);
    }




    /**
     * Trae todos los tramites activos sin importar sede
     */
    public getTramitesFuncionario() {
        const serviceProvider = 'tramiteUAC';
        const pathParams: Array<[string, string]> = new Array<[string, string]>();
        pathParams.push(['filterBy=estado', ConstantesService.ESTADO_TRAMITE_ACTIVO]);
        let url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, pathParams, null), this.urlService.hostAPI_UAC);
        url = url + '&orderBy=nombre$ASC';
        this.global.getGenerico(url).subscribe(
            data => {
                this.tramitesFuncionario = data;

            }, err => {
                this.cathException('Ocurrio un error en la consulta de los servicios');
            }
        );
    }


    /**
     * consulta los tramites de la tabla tramite_uac validar tramite de la venttanilla actual
     * @author fromero
     */
    private getTramites() {

        this.spiner.show();
        const serviceProvider = 'tramiteUAC';
        const pathParams: Array<[string, string]> = new Array<[string, string]>();
        pathParams.push(['filterBy=estado', ConstantesService.ESTADO_TRAMITE_ACTIVO]);
        var url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, pathParams, null), this.urlService.hostAPI_UAC);
        const sucripcion = this.global.getGenerico(url).subscribe(
            data => {
                this.listaTramites = data;
                const tramite = this.listaTramites.filter(el => {
                    if (el.idTramite == this.tramiteActual.idTramite) {
                        return el;
                    }
                });
                console.log(this.listaTramites);

                //this.tramiteActual.nombre = tramite[0].nombre;
                this.ordenarListaTramites();
                this.consultarTurnosTramite();

            }, err => {
                this.cathException('Error Consultando la lista de tramites');
            }
        );

        this.subscription.push(sucripcion);
    }

    /**
     * mostrar un spinner especìfico de la aplicación por nombre
     * @param spinner 
     * @author fromero
     */
    verSpinner(spinner) {
        this.contadorUAC = 0;
        this.global.setContadorUAC(this.contadorUAC);
        this.spiner.show(spinner);
        this.inhabilitarBotonEspera = true;
        this.timerSpinner = setInterval(() => {
            this.contadorUAC = this.contadorUAC + 1;
            this.global.setContadorUAC(this.contadorUAC);
        }, 1000);

        this.timerDistraido = setTimeout(() => {
            this.spiner.hide("sp6");
            this.contadorUAC = 0;
            this.turnoLlamado = false;
            this.inhabilitarBotonEspera = false;
            this.setTurnoDistraido();
        }, this.tiempoContador);
    }



    /**
     * actualiza el estado del turno a distraido
     * @author fromero
     */
    setTurnoDistraido() {
        console.log('Llamo de metodo turno distraido');

        clearInterval(this.timerSpinner);
        this.inhabilitarBotonLlamar = false;
        this.spiner.show();
        const serviceProvider = 'turnoDistraidoUac';
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
        const sucripcion = this.global.postGenerico(url, this.turno).subscribe(
            data => {
                console.log('Respuesta turno distraido');
                this.modalOptionsAbandono.disabled = true;
                this.consultarTurnosTramite();
                this.spiner.hide();
                this.turno = new TurnoUACModel();
                this.inhabilitarBotonLlamar = false;
                this.inhabilitarBotonAtencion = true;
                if (!this.turnoLlamado) {
                    console.log('Llamado de turno distraido');
                    const timer = setTimeout(() => {
                        this.llamarTurnoUac();
                    }, this.timerLlamadoAutomatico);
                    this.timeOutllamadoAutomatico.push(timer);
                }
            }, err => {
                this.cathException(err.error.message);
            }
        );
        this.subscription.push(sucripcion);
    }

    /**
     * detiene el timeout que hace la peticiòn de turno distraido
     * @author fromero
     */
    stopTimerDistraido() {
        clearTimeout(this.timerDistraido);
        clearInterval(this.timerSpinner);
        this.spiner.hide(this.spinner1);
    }

    /**
     * muestra el modal de atenciòn de un ciudadano
     * @author fromero
     */
    iniciarAtencionTurno() {

        this.stopTimerDistraido();
        this.spiner.show();
        const serviceProvider = 'iniciarAtencionTurno';
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
        const sucripcion = this.global.postGenerico(url, this.turno).subscribe(
            data => {
                this.inhabilitarCambioTramite = true;
                this.spiner.hide();
                this.guardarInicioAtencionciudadano();
            }, err => {
                this.cathException('Error Consultando la lista de turnos por tramite');
            }
        );
        this.subscription.push(sucripcion);
    }

    /**
     * llama el modal de atenciòn al ciudadano
     * @author fromero
     */
    guardarInicioAtencionciudadano() {
        const modalRef = this.modalService.open(AtencionCiudadanoUACComponent,
            { centered: true, backdrop: 'static', keyboard: false, size: 'lg' });
        this.turno.nombreTramite = this.tramiteActual.nombre;
        this.turno.idTramite = this.tramiteActual.idTramite;
        modalRef.componentInstance.turno = this.turno; // Objeto que se envìa al modal para ediciòn
        modalRef.componentInstance.listaTramites = this.listaTramites;
        modalRef.componentInstance.tramiteActual = this.tramiteActual;
        modalRef.result.then(turno => {
            this.inhabilitarCambioTramite = false;
            if (turno) {
                this.peticionFinalizarAtencionCiudadano();
            } else {
                this.turno = new TurnoUACModel();
                this.inhabilitarBotonLlamar = false;
                this.inhabilitarBotonAtencion = true;
                this.inhabilitarCambioTramite = true;
                const timer = setTimeout(() => {
                    this.llamarTurnoUac();
                }, this.timerLlamadoAutomatico);
                this.timeOutllamadoAutomatico.push(timer);
            }
        });
    }

    /**
     * llamado al servicio de finalizaciòn de atenciòn ciudadano
     * @author fromero
     */
    peticionFinalizarAtencionCiudadano() {
        this.spiner.show();
        const serviceProvider = 'finalizarTurnoCiudadano';
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
        this.turno.tipoIdFuncionario = sessionStorage.getItem('tipoDocumento');
        this.turno.numIdFuncionario = sessionStorage.getItem('numDocumento');
        this.turno.numeroIdFuncionario = this.turno.numIdFuncionario;
        const sucripcion = this.global.postGenerico(url, this.turno).subscribe(
            data => {
                this.inhabilitarBotonLlamar = false;
                this.inhabilitarBotonAtencion = true;
                this.alertService.generateAlertSuccess(data.mensaje, '');
                this.spiner.hide();
                this.turno = new TurnoUACModel();
                const timer = setTimeout(() => {
                    this.llamarTurnoUac();
                }, this.timerLlamadoAutomatico);
                this.timeOutllamadoAutomatico.push(timer);
            }, err => {
                this.iniciarAtencionTurno();
                this.cathException(err.error.message);
            }
        );
        this.subscription.push(sucripcion);
    }

    /**
     * obtiene el dominio de tipos de documento
     * @author fromero
     * 
     */
    public getTipoIdentificacion() {
        const serviceProvider = 'getTipoIdentificacion';
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
        const sucripcion = this.global.getGenerico(url).subscribe(
            data => {
                this.listadoTipoDocumento = data;
            }, err => {
                this.cathException('Error Consultando el Dominio');
            }
        );
        this.subscription.push(sucripcion);
    }



    /**
     * metodo para validar numero docunmento y tipo del funcionario antes de hacer peticiòn
     * @param event 
     * @author fromero
     */
    public setDocumento(event) {
        this.turnoFuncionario.tipoDocumentoFuncionario = event.target.value;

        if (this.turnoFuncionario.numeroDocumentoFuncionario) {
            this.obtenerFuncionario(this.turnoFuncionario.numeroDocumentoFuncionario);
        }
    }
    /**
     * metodo para obtener un funcionario para un turno validar camilo
     * @author fromero
     * @param numerodocumento 
     */
    obtenerFuncionario(numerodocumento) {
        if (numerodocumento.length >= 1 && this.turnoFuncionario.tipoDocumentoFuncionario
            && this.turnoFuncionario.tipoDocumentoFuncionario != '') {
            this.spiner.show();
            const serviceProvider = 'buscarFuncionarioUac';
            var queryParams: Array<[string, string]> = new Array<[string, string]>();
            queryParams.push(['tipoDocFunc', this.turnoFuncionario.tipoDocumentoFuncionario]);
            queryParams.push(['numDocFunc', numerodocumento]);
            const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);

            const subscribe = this.global.getGenerico(url).subscribe(data => {
                this.turnoFuncionario.nombreCompleto = null;
                if (data) {
                    this.turnoFuncionario = data;
                    this.inhabilitarBotonFuncionario = false;
                } else {
                    this.alertService.generateAlertError('El documento consultado no se encuentra registrado'
                        + 'como funcionario, por favor intente con otro número de documento', '');
                }
                this.spiner.hide();
            }, err => {
                this.cathException('Error al obtener funcionario');
            });
            this.subscription.push(subscribe);
        }
    }

    /**
     * inicia la atenciòn de un funcionario uac
     * @author fromero
     */
    iniciarAtencionFuncionario() {

        this.stopLlamadoAutomatico();
        this.stopTimerDistraido();
        this.inhabilitarBotonFuncionario = true;
        this.modalOptionsFinFuncionario.disabled = false;
        this.inhabilitarCampos = true;
        this.inhabilitarBotonBuscarFuncionario = true;

        this.servicioFuncionario = new ServicioFuncionarioModel(
            null,
            this.tramiteActual.idTramite,
            new Date(),
            null,
            this.ventanillaActual,
            this.sedeActual,
            this.turnoFuncionario.tipoDocumentoFuncionario,
            this.turnoFuncionario.numeroDocumentoFuncionario,
            sessionStorage.getItem('tipoDocumento'),
            sessionStorage.getItem('numDocumento')
        );


    }

    /**
     * finaliza la atenciòn de un funcionario uac
     * @author fromero
     */
    finalizarAtencionFuncionario(event) {

        if (event[0]) {

            this.servicioFuncionario.fechaFinalAtencion = new Date();

            this.spiner.show();
            const serviceProvider = 'servicioServicioFuncionario';
            const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
            const sucripcion = this.global.postGenerico(url, this.servicioFuncionario).subscribe(
                data => {
                    this.turnoFuncionario = new TurnoFuncionarioUACModel();
                    this.servicioFuncionario = new ServicioFuncionarioModel(null, null, null, null, null, null, null, null, null, null);
                    this.inhabilitarCampos = false;
                    this.modalOptionsFinFuncionario.disabled = true;
                    this.inhabilitarBotonFuncionario = true;
                    this.inhabilitarBotonBuscarFuncionario = false;
                    this.inhabilitarBotonAtencion = true;
                    this.alertService.generateAlertSuccess('Se finaliza la atención del turno exitosamente', '');
                    this.spiner.hide();
                }, err => {
                    this.cathException('Ocurrio un error al intentar guardar la atenciòn del funcionario');
                }
            );
            this.subscription.push(sucripcion);
        }
    }

    /**
     * valida el tràmite y habilita el boton de cambio de tràmite
     * @author fromero
     */
    public validarCambioTramite() {

        if (this.tramiteActual && this.tramiteActual.nombre != 'null') {
            this.modalOptionsCambioTramite.disabled = false;
        }

    }

    /***
     * mètodo que actualzia el tramite de la ventanilla
     * @author fromero
     */
    public cambiarTramite(event) {

        if (event[0]) {
            this.tramiteActual = this.tramiteAtender;
            this.modalOptionsCambioTramite.disabled = true;
            this.inhabilitarBotonAtencion = true;
            this.tipoTramite = this.tramiteAtender.nombre;
            this.stopLlamadoAutomatico();
            this.stopTimerDistraido();
            this.alertService.generateAlertSuccess('Se realizó el cambio de Servicio con exito. Servicio actual: ' +
                this.tramiteAtender.nombre, '');
            this.consultarTurnosTramite();
        }

        // if (event[0]) {
        //     this.spiner.show();
        //     const serviceProvider = 'actualizarTramiteVentanilla';
        //     const queryParams: Array<[string, string]> = new Array<[string, string]>();
        //     queryParams.push(['idTramite', this.tramiteAtender.idTramite.toString()]);
        //     queryParams.push(['idVentanilla', this.ventanillaActual]);
        //     queryParams.push(['tipoDocFunc', sessionStorage.getItem('tipoDocumento')]);
        //     queryParams.push(['numDocFunc', sessionStorage.getItem('numDocumento')]);
        //     queryParams.push(['sede', this.sedeActual]);

        //     const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        //     const sucripcion = this.global.getGenerico(url).subscribe(
        //         data => {
        //             this.alertService.generateAlertSuccess(data.mensaje, '');
        //             this.tramiteActual = this.tramiteAtender;
        //             this.modalOptionsCambioTramite.disabled = true;
        //             this.inhabilitarBotonAtencion = true;
        //             this.tipoTramite = this.tramiteAtender.nombre;
        //             this.consultarTurnosTramite();
        //             this.spiner.hide();
        //         }, err => {
        //             this.cathException(err.error.message);
        //         }
        //     );
        //     this.subscription.push(sucripcion);
        // }
    }

    /**
     * mètodo que llama el servicio de abandono de turno y vuelve a solicitar el turno siguiente
     * @author fromero
     * @param event 
     */
    public abandonarTurno(event) {
        if (event[0]) {
            this.spiner.show();
            const serviceProvider = 'abandonarturnoUac';
            this.stopTimerDistraido();
            this.turno.numIdFuncionario = sessionStorage.getItem('numDocumento');
            this.turno.tipoIdFuncionario = sessionStorage.getItem('tipoDocumento');

            const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
            const sucripcion = this.global.postGenerico(url, this.turno).subscribe(
                data => {
                    this.inhabilitarBotonLlamar = false;
                    this.inhabilitarBotonEspera = false;
                    this.inhabilitarCambioTramite = false;
                    this.inhabilitarBotonAtencion = true;
                    this.alertService.generateAlertSuccess(ConstantesService.mensajeConfirmacionAbandonoUAC, '');
                    this.turno = new TurnoUACModel();
                    this.spiner.hide();
                    const timer = setTimeout(() => {
                        this.llamarTurnoUac();
                    }, this.timerLlamadoAutomatico);
                    this.timeOutllamadoAutomatico.push(timer);
                }, err => {
                    this.cathException(err.error.message);
                }
            );
            this.subscription.push(sucripcion);
        }
    }


    /**
     * muestra el modal de selecciòn de ventanilla en espera
     * @author fromero
     */
    ventanillaEspera() {

        this.stopLlamadoAutomatico();
        this.stopTimerDistraido();
        this.spiner.hide(this.spinner1);
        const modalRef = this.modalService.open(VentanillaEsperaUACComponent,
            { centered: true });
        modalRef.componentInstance.numeroVentanilla = this.ventanillaActual;
        modalRef.componentInstance.sede = this.sedeActual;
        modalRef.result.then(resp => {
            if (resp) {
                this.inhabilitarBotonEspera = true;
                this.stopLlamadoAutomatico();
            }
        });

    }

    /**
     * método que abre el modal de consulta de turnos UAC pendientes por devolución de documentos
     * @author  fromero
     */
    consultaTurnosUac() {
        this.ventanillaDisponible();
        const modalRef = this.modalService.open(ConsultaTurnosUACComponent,
            { centered: true, size: 'lg' });
        modalRef.componentInstance.idTramite = this.tramiteActual;
        modalRef.componentInstance.ventanillaActual = this.ventanillaActual;
        modalRef.componentInstance.sedeActual = this.sedeActual;

        modalRef.result.then(turno => {
            if (turno) {
                this.turno = turno;
                this.llamarTurnoPendienteDocs(turno);
                this.guardarInicioAtencionciudadano();
            }
        });
    }

    /**
     * @function llamarTurnoPendienteDocs
     * @author dfranco@asesoftware.com
     * @param  turno DTO que contiene la definición del turno
     */
    llamarTurnoPendienteDocs(turno: TurnoUACModel) {
        const serviceProvider = 'llamarTurnoPendienteDocs';
        const url = this.urlService.getUrlUAC(
            new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
        this.global.postGenerico(url, turno).subscribe(
            data => { },
            err => {
                if (err.status == '500') {
                    this.cathException(err.error.message);
                } else {
                    this.cathException('Error al notificar turno en pantalla');
                }
            }
        );
    }

    /**
     * @author fromero
     * metodo para consultar la lista de turnos de un tramite
     */
    consultarTurnosTramite() {
        console.log('Consulta turnos del tramite');

        this.spiner.show();
        const serviceProvider = 'consultaTurnosPorTramite';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['idTramite', this.tramiteActual.idTramite.toString()]);
        queryParams.push(['sede', this.sedeActual]);

        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        const sucripcion = this.global.getGenerico(url).subscribe(
            data => {
                console.log('Respuesta de consulta turnos por tramite');

                if (data.length === 0 && !this.turnoLlamado && this.tipoTramite !== ConstantesService.ID_TRAMITE_FUNCIONARIO) {
                    const timer2 = setTimeout(() => {
                        console.log('Llamada de turnos por tramite');
                        this.llamarTurnoUac();
                    }, this.timerLlamadoAutomatico * 2);
                    this.timeOutllamadoAutomatico.push(timer2);
                    this.inhabilitarCambioTramite = false;
                }
                this.turnosTramite = data;
                this.turnosAsignados = this.turnosTramite.length.toString();
                this.spiner.hide();
            }, err => {
                this.cathException('Error Consultando la lista de turnos por tramite');
            }
        );
        this.subscription.push(sucripcion);
    }

    /**
     * Finaliza los timers que esten en espera de llamado automático
     * @author fromero
     */
    stopLlamadoAutomatico() {
        this.timeOutllamadoAutomatico.forEach(timer => {
            clearTimeout(timer);
        });
    }

    /**
     * mètodo pra solicitar el siguiente turno a atender en la ventanilla
     * @author  fromero
     */
    llamarTurnoUac() {

        this.stopLlamadoAutomatico();
        this.ventanillaDisponible();
        this.inhabilitarBotonLlamar = true;
        this.spiner.show();
        const serviceProvider = 'llamarTurnoUac';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['idTramite', this.tramiteActual.idTramite.toString()]);
        queryParams.push(['numeroVentanilla', this.ventanillaActual.toString()]);
        queryParams.push(['sede', this.sedeActual]);
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        const sucripcion = this.global.getGenerico(url).subscribe(
            data => {
                this.turno = data;
                this.turno.nombreTramite = this.tramiteActual.nombre;
                this.modalOptionsAbandono.disabled = false;
                this.inhabilitarBotonAtencion = false;
                this.inhabilitarBotonTransferir = false;
                this.verSpinner(this.spinner1);
                this.consultarTurnosTramite();
                this.inhabilitarBotonEspera = true;
                this.inhabilitarCambioTramite = true;
                this.turnoLlamado = true;
            }, err => {
                if (this.ultimoError !== err.error.message) {
                    this.ultimoError = err.error.message;
                    this.cathException(err.error.message);
                }
                this.modalOptionsAbandono.disabled = true;
                this.inhabilitarBotonAtencion = true;
                this.inhabilitarBotonTransferir = true;
                this.inhabilitarBotonLlamar = false;
                this.turnoLlamado = false;
                this.consultarTurnosTramite();
            }
        );
        this.subscription.push(sucripcion);
    }


    /**
     * metodo que realiza la petición de actualización de estado ventanilla
     * @author fromero
     * @param event
     */
    ventanillaDisponible() {
        if (this.inhabilitarBotonEspera) {
            this.spiner.show();
            const serviceProvider = 'ventanillaEspera';
            var queryParams: Array<[string, string]> = new Array<[string, string]>();
            queryParams.push(['numeroVentanilla', this.ventanillaActual]);
            queryParams.push(['motivoEspera', null]);
            queryParams.push(['sede', this.sedeActual]);
            queryParams.push(['estado', 'ACT']);
            const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
            const sucripcion = this.global.getGenerico(url).subscribe(
                data => {
                    this.inhabilitarBotonEspera = false;
                    this.inhabilitarBotonAtencion = true;
                    this.alertService.generateAlertSuccess(data.mensaje, '');
                    this.spiner.hide();
                }, err => {
                    this.cathException(err.error.message);
                }
            );
            this.subscription.push(sucripcion);
        }
    }


    /**
     * 
     * @param error 
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spiner.hide();
    }

    /**
     * Ordena la lista de tramites
     * @author fromero
     */
    ordenarListaTramites() {
        this.listaTramites.sort(
            function (a, b) {
                if (a.idTramite > b.idTramite) {
                    return 1;
                }
                if (a.idTramite < b.idTramite) {
                    return -1;
                }
                // a must be equal to b
                return 0;
            });
    }

    /**
     * mètodo que cancela las subcripciones si se destruye el componente
     * @author fromero
     */
    ngOnDestroy() {
        this.stopLlamadoAutomatico();
        this.stopTimerDistraido();
        this.subscription.forEach(e => {
            e.unsubscribe();
        });


    }
}
